import CardActionButtonList from '../action-formatters/CardActionButtonList';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormattedCard({
  title: titleOverride,
  hasActionsLoadingError,
  cardData,
  actionConfigs,
  actionComponent,
  CardFormatter,
  ActionFormatter = CardActionButtonList,
  children,
  legacyDataAttributes,
  usageTracker
}) {
  const title = titleOverride ||
  // Be extra safe getting the title here because this is used in error boundaries and we really don't want any errors here
  cardData && cardData.definition && cardData.definition.cardTitle;
  const cardType = cardData && cardData.definition && cardData.definition.cardType;
  return /*#__PURE__*/_jsx(CardFormatter, {
    legacyDataAttributes: legacyDataAttributes,
    title: title,
    cardType: cardType,
    actionConfigs: actionConfigs,
    actionComponent: actionComponent,
    cardId: cardData.definition.cardId,
    hasActionsLoadingError: hasActionsLoadingError,
    isCollapsed: cardData.isCollapsed,
    ActionFormatter: ActionFormatter,
    usageTracker: usageTracker,
    children: children
  });
}